<div id="modal_entrega_sim">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-cobertura">
        <div class="card-header bg-black modal-header">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h5 class="subtitulo-pack2"><b>Entrega SIM</b></h5>
            </div>
          </div>
        </div>
        <div class="card-body bg-white modal-body">
          <div class="row radio-btn-group">
            <div class="col-lg-6">
              <!-- Entregar SIM en tienda -->
              <div class="jumbotron-ad mt-2">
                <div class="row">
                  <div class="col-md-9 pt-3">
                    <h5><span class="fw-bold">¿Entregar SIM en tienda?</span></h5>
                    <p><img src="./assets/img/times.svg" class="img-fluid" width="13"> Terminales no disponibles
                      <br><img src="./assets/img/times.svg" class="img-fluid" width="13"> Tarifa amena en casa no disponible</p>
                  </div>
                  <div class="col-md-3">
                    <div class="radio radio-pack">
                      <input id="click_me22" type="radio" name="radio" value="click_me22" v-model="checked">
                      <label for="click_me22" (click)="entregarSimEnTienda()">Aceptar</label>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-lg-6">

              <!-- Enviar SIM por logística -->
              <div class="jumbotron-ad mt-2">
                <div class="row">
                  <div class="col-md-9 pt-3">
                    <h5><span class="fw-bold">¿Enviar SIM por logística?</span></h5>
                    <p><img src="./assets/img/check1.svg" class="img-fluid" width="13"> Terminales disponibles
                      <br><img src="./assets/img/check1.svg" class="img-fluid" width="13"> Tarifa amena en casa disponible</p>


                  </div>
                  <div class="col-md-3">
                    <div class="radio radio-pack">
                      <input id="click_me23" type="radio" name="radio" value="click_me23" v-model="checked">
                      <label for="click_me23" (click)="entregarSimLogistica()">Aceptar</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

